
import { PropType, defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    isNewMember: {
      type: Boolean,
      default: () => false,
    },

    items: {
      type: Array as PropType<any[]>,
      default: () => [],
    },

    forceOpen: {
      type: Boolean,
      default: () => false,
    },
  },

  setup(props) {
    const accordion = ref<HTMLElement>();
    const total = ref<number>(0);

    let count = 0;
    for (const item of props.items) {
      count += item.quantity;
    }
    total.value = count;

    const toggleAccordion = () => {
      if (!accordion.value || props.forceOpen) return;
      accordion.value.classList.toggle("open");
    };

    return {
      total,
      accordion,
      toggleAccordion,
    };
  },
});
